<template>
  <div>
    <b-modal
      centered
      id="modal-birthday-notifications"
      title="Дні народження сьогодні"
    >
      <b-list-group v-for="birthday in birthdays" :key="birthday.id">
        <b-list-group-item href="#" class="d-flex align-items-center">
          <b-avatar
            class="mr-3"
            :src="`https://194.61.53.21:4545/trainers/photo/${birthday.id}`"
          ></b-avatar>
          <span class="mr-auto"
            >{{ birthday.name }} {{ birthday.surname }}</span
          >
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "BirthdayNotifier",
  props: {
    birthdays: Array,
  },
};
</script>

<style scoped></style>
